import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-api-key-dialog',
  imports: [MatDialogModule, MatButtonModule, MatIconModule],
  template: `
    <h2 mat-dialog-title>API Key for "{{ data.username }}"</h2>
    <mat-dialog-content>
      <p>Copy this key now — it is shown only once and cannot be retrieved later.</p>
      <code class="key">{{ data.apiKey }}</code>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="copy()"><mat-icon>content_copy</mat-icon> Copy</button>
      <button mat-flat-button mat-dialog-close>Done</button>
    </mat-dialog-actions>
  `,
  styles: `.key { display: block; word-break: break-all; padding: 12px; border-radius: 4px; background: rgba(128, 128, 128, 0.15); user-select: all; }`
})
export class ApiKeyDialog {
  readonly data = inject<{ username: string; apiKey: string }>(MAT_DIALOG_DATA);
  private snackBar = inject(MatSnackBar);

  copy(): void {
    navigator.clipboard.writeText(this.data.apiKey).then(
      () => this.snackBar.open('API key copied', 'Close', { duration: 3000 }),
      () => this.snackBar.open('Could not copy — select and copy it manually', 'Close', { duration: 5000 })
    );
  }
}
